import { Component, Input, OnInit } from '@angular/core';
import { CustomerListItem } from '../shared/models/customer-list-view-model';

@Component({
    selector: 'app-customer-list-item',
    templateUrl: './customer-list-item.component.html',
    styleUrls: ['./customer-list-item.component.scss'],
    standalone: false
})
export class CustomerListItemComponent implements OnInit {

  @Input() company: CustomerListItem;

  constructor() { }

  ngOnInit(): void {
  }

}
